import React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { useTranslation } from 'react-i18next';

const DeliveryTrendChart = ({ data }) => {
    const { t } = useTranslation();
    const strings = t('deliveryAnalytics.charts.trend', { returnObjects: true });
    // data.data may be empty if no challans in period — show empty state
    const chartData = data?.data || [];

    return (
        <div style={cardStyle}>
            <div style={headerStyle}>
                <div>
                    <span style={titleStyle}>{strings.challanTitle}</span>
                    <div style={subtitleStyle}>{strings.subtitle}</div>
                </div>
                {chartData.length > 0 && (
                    <div style={{ display: 'flex', gap: 16 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <div style={{ width: 10, height: 10, borderRadius: 2, backgroundColor: '#3b82f6' }} />
                            <span style={{ fontSize: 12, color: '#6b7280' }}>{strings.weightTon}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <div style={{ width: 10, height: 10, borderRadius: 2, backgroundColor: '#a78bfa' }} />
                            <span style={{ fontSize: 12, color: '#6b7280' }}>{strings.challans}</span>
                        </div>
                    </div>
                )}
            </div>

            {chartData.length === 0 ? (
                <div style={{ padding: '60px 20px', textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>
                    <div style={{ fontSize: 32, marginBottom: 8 }}>📦</div>
                    {strings.empty}
                </div>
            ) : (
                <div style={{ width: '100%', height: 300, padding: '0 16px 16px' }}>
                    <BarChart
                        series={[
                            {
                                data: chartData.map(d => parseFloat(d.total_weight_tons) || 0),
                                label: strings.weightTon,
                                color: '#3b82f6',
                                yAxisKey: 'weight',
                            },
                            {
                                data: chartData.map(d => d.challan_count || 0),
                                label: strings.challans,
                                color: '#a78bfa',
                                yAxisKey: 'challans',
                            },
                        ]}
                        xAxis={[{
                            data: chartData.map(d =>
                                new Date(d.date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' })
                            ),
                            scaleType: 'band',
                            tickLabelStyle: { fontSize: 11, fill: '#9ca3af' },
                        }]}
                        yAxis={[
                            { id: 'weight', position: 'left', tickLabelStyle: { fontSize: 10, fill: '#9ca3af' } },
                            { id: 'challans', position: 'right', tickLabelStyle: { fontSize: 10, fill: '#9ca3af' } },
                        ]}
                        slotProps={{ legend: { hidden: true } }}
                        margin={{ top: 10, right: 50, bottom: 40, left: 55 }}
                        borderRadius={4}
                    />
                </div>
            )}
        </div>
    );
};

const cardStyle = { backgroundColor: '#fff', borderRadius: 16, border: '1px solid #f3f4f6', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', overflow: 'hidden', height: '100%' };
const headerStyle = { padding: '18px 20px 12px', borderBottom: '1px solid #f9fafb', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 8 };
const titleStyle = { fontSize: 15, fontWeight: 700, color: '#111827', display: 'block' };
const subtitleStyle = { fontSize: 12, color: '#9ca3af', marginTop: 2 };

export default DeliveryTrendChart;
